/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcFundingV1SourceEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_FUNDING_V1_SOURCE_EVENT_ENTITY_NAME = 'ixc.funding.v1.SourceEvent';
export const ixcFundingV1SourceEventEntity = new schema.Entity<IxcFundingV1SourceEvent>(IXC_FUNDING_V1_SOURCE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcFundingV1SourceEvent) => `${entity.metadata?.eventId}` });

